import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeAllUsersList } from './normalize';

export const fetchAllUsersList = createProvider(api.fetchAllUsersList)
  .andThen((res) => normalizeAllUsersList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
